import { Injectable, Injector } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslationService } from '../appServices/translation.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderUtility {
  private loader: any;

  constructor(private injector: Injector) {}

  async showLoader() {
    const loadingCtrl = this.injector.get(LoadingController);
    const translate = this.injector.get(TranslationService);

    const message = translate.translate('PLEASE_WAIT');
    this.loader = await loadingCtrl.create({ message });
    this.loader.present();
  }

  async showLoaderWithMsg(msgKey: string) {
    const loadingCtrl = this.injector.get(LoadingController);

    const message = msgKey;
    this.loader = await loadingCtrl.create({ message });
    this.loader.present();
  }

  async hideLoader() {
    const loadingCtrl = this.injector.get(LoadingController);

    await this.loader?.dismiss();
    const isLoaderExist = await loadingCtrl.getTop();
    if (isLoaderExist) loadingCtrl.dismiss();
  }
}
